import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';

export const SIDEBAR_FULLSCREEN_CONTAINER_ID = 'sidebar-fullscreen-container';

export class SidebarFullscreenContainer extends Component<{
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}> {
  @tracked isFullscreen = this.getFullscreenStatus();

  trackFullScreen = modifier(() => {
    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = this.getFullscreenStatus();
    });
  });

  getFullscreenStatus() {
    return document.fullscreenElement !== null;
  }

  <template>
    <div
      id={{SIDEBAR_FULLSCREEN_CONTAINER_ID}}
      {{this.trackFullScreen}}
      class="text-bg-white
        {{if this.isFullscreen 'll-sidebar-fullscreen' 'll-sidebar-window'}}"
      ...attributes
    >
      {{yield}}
    </div>
  </template>
}
